import { Injectable } from '@angular/core';
import { IAddress } from "../../hotel/models/address";
import { IHotel } from "../../hotel/models/hotel";

@Injectable()
export class NewFormatToOldService {

    public transformAddressNewFormatToOld(newAddress: any): IAddress {
        const isNewFormat: boolean = Boolean(newAddress.streetLineArray ||  newAddress.city?.nameArray);
        if (!isNewFormat) {
            return newAddress;
        }

        const city: { name: { value: string } } = newAddress.city?.nameArray?.length ?
            {
                name: {
                    value: newAddress.city.nameArray[0].value
                }
            }:
            null;

        return {
            city,
            country: {
                iso: newAddress.country?.iso
            },
            streetLines: [newAddress.streetLineArray],
            textLines: [
                newAddress.streetLineArray,
                newAddress.zipCode,
                city?.name.value,
                newAddress.state?.code,
                newAddress.country?.iso
            ].filter((line: string): boolean => Boolean(line)),
            zipCode: newAddress.zipCode,
            number: newAddress.number
        };
    }

    public transformHotelNewFormatToOld(newHotel: any): IHotel {
        if (typeof newHotel.name === 'string') {
            return newHotel;
        }
        return {
            name: newHotel.name.value,
            status: newHotel.status,
            hostCode: newHotel.host?.code,
            address: newHotel.address,
            airportClosest: newHotel.airportClosest,
            city: newHotel.citynameArray ? newHotel.citynameArray[0] : null,
            country: newHotel.country.iso,
            dateLastCancellationWithoutPenalty: newHotel.quote?.dateLastCancellationWithoutPenalty,
            geoposition: {
                latitude: newHotel.latitude,
                longitude: newHotel.longitude
            },
            host: newHotel.host,
            id: newHotel.id,
            keyword: newHotel.keywordArray,
            mealplan: newHotel.quote?.mealplan,
            property: newHotel.quote?.property,
            rank: newHotel.quote?.rank,
            rating: newHotel.rating,
            sites: newHotel.siteArray,
            syscode: "",
            telephones: newHotel.telephoneArray,
            total: newHotel.quote?.total,
            xId: newHotel.xId,
            zipcode: newHotel.zipCode
        };
    }
}

/*             state: {
                code: newAddress.state.code
                //name: {value: newAddress.country.nameArray[0].value}
            },*/
